import React from "react";
import Term, { TermData } from "../Term";
import { shopArchiveURIs } from "./variables";

export const genreAll = -1;
export const genreOther = -2;
export const genreOtherSlug = "other";
export const genreNone = -9999;

const defalutGenres: { [name: string]: TermData } = {
  all: {
    id: genreAll,
    term_meta: {
      color: "#E39696",
      icon: '<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8976 1.35229C23.5323 1.98706 23.5323 3.01792 22.8976 3.65269L9.89756 16.6527C9.26279 17.2875 8.23193 17.2875 7.59717 16.6527L1.09717 10.1527C0.462402 9.51792 0.462402 8.48706 1.09717 7.85229C1.73193 7.21753 2.76279 7.21753 3.39756 7.85229L8.7499 13.1996L20.6022 1.35229C21.237 0.717529 22.2679 0.717529 22.9026 1.35229H22.8976Z" fill="white"/></svg>',
      text: "ALL",
    },
    slug: "",
    url: shopArchiveURIs.home,
  },
  other: {
    id: genreOther,
    term_meta: {
      color: "#ACC9CF",
      icon: '<svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5321 18.2029H15.3516C15.6146 16.2095 19.2414 16.3479 19.5321 18.2029Z" fill="white"/><path d="M16.9852 15.9048C15.7532 15.6141 15.6424 13.3577 17.3174 13.1916C19.38 12.9978 19.0893 16.4032 16.9852 15.9048Z" fill="white"/><path d="M11.7386 15.9047C9.95285 16.2508 9.24687 13.3852 11.3233 13.1914C12.9983 13.053 13.2475 15.614 11.7386 15.9047Z" fill="white"/><path d="M13.539 18.1198C12.2793 18.3136 10.6735 18.1475 9.27539 18.2028C9.63531 16.2925 13.0822 16.3202 13.539 18.1198Z" fill="white"/><path d="M7.79423 11.9734C7.84961 11.2813 7.68349 10.3954 7.87729 9.84166H8.77708V10.9907H20.0175V1.54977H8.77708C8.72171 3.28014 8.88783 5.21811 8.69402 6.79621H7.79423C7.84961 4.74746 7.68349 2.47722 7.87729 0.566895H21.0004V11.9734H7.79423Z" fill="white"/><path d="M3.86197 3.3494C1.68863 3.86159 0.733468 0.580823 2.87912 0.0686349C5.37084 -0.52661 5.6477 2.93411 3.86197 3.3494Z" fill="white"/><path d="M3.28077 8.1944C4.0975 7.72374 3.66837 6.00723 3.76527 4.83058H2.78243C2.89317 5.99339 2.43635 7.73759 3.26693 8.1944H3.28077ZM4.51279 18.0367C3.91754 18.2997 2.40867 18.2859 1.81342 18.0367C1.34276 16.4863 1.50888 14.2853 1.31508 12.458C0.609089 12.5411 0.152272 12.3611 0 11.8904V5.73032C0.221487 5.30119 0.484502 4.56759 1.23202 4.33226C2.03491 4.06924 5.13572 4.02772 5.82787 4.33226C6.9353 4.8306 6.65844 6.67169 6.97683 7.86219C7.6136 7.86219 8.26422 7.8345 8.79025 7.94524C9.81463 7.52995 10.7421 5.93803 11.9049 6.22873C11.4066 7.29464 10.2161 7.65452 9.35781 8.36051C9.37165 9.50947 6.85224 9.91095 5.82787 9.26033C5.20494 8.85889 5.52332 8.22211 5.17725 7.69608C4.85886 11.0322 5.17725 15.0328 4.51279 18.0367Z" fill="white"/></svg>',
      text: "Other",
    },
    slug: genreOtherSlug,
    url: shopArchiveURIs.genre + "other",
  },
};

export const getGenreIds = (genres: TermData[]): number[] =>
  genres.map((genre) => genre.id);

const Genres: React.FC<{
  genres: TermData[];
}> = ({ genres }) => {
  return (
    <>
      <div className="genre-term">
        <div className="genre-term__title">ジャンルから探す</div>
        <div className="genre-term__tags">
          {[defalutGenres["all"], ...genres, defalutGenres["other"]].map(
            (genre) => (
              <Term key={genre.id} term={genre} classNamePrefix="genre-term" />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default Genres;
